export default {
  search: 20,
  searchCommunities: 12,
  searchMembers: 12,
};
